import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CRV } from 'services/_path';
import { Types } from './types';
import { consultaEspecieSuccess, consultaEspecieFailure } from './actions';

function* consultaEspecieRequest() {
	const response: ApiResponse = yield call(
		getApi,
		PATH_DETRAN_CRV,
		`consultas/${CHANNEL}/consulta-especie`,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultaEspecieSuccess(response));
	} else if (response.error) {
		yield put(consultaEspecieFailure(response.message));
	}
}

export default all([
	takeLatest(Types.CONSULTA_ESPECIE_REQUEST, consultaEspecieRequest),
]);
